import { Injectable } from '@angular/core';

import { ILanguageItem } from './interfaces';

@Injectable({
    providedIn: 'root'
})
export class LanguageSelectorService {
    getLanguage(eventLanguages: ILanguageItem[], storedLanguage: string, preferredLanguage: string | null): string {
        const eventLanguageFromStorage = eventLanguages.find(x => x.id === storedLanguage);
        const preferredEventLanguage = eventLanguages.find(x => x.id === preferredLanguage);
        // The order of precedence is (if found in event languages):
        // - Language from storage
        // - Preferred language
        // - The first event language
        return eventLanguageFromStorage?.id || preferredEventLanguage?.id || eventLanguages[0].id;
    }
}
